import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Suspense, useContext, useEffect, useRef, useState } from "react";
import Icon from "../../../base/icons/icon/index.js";
import { getSearcherData, getSearcherModel } from "../searcher-tabs/service.js";
import contextBabylon from "../../../../context/index.js";
import { renderSearcherSkeleton } from "../../../../helpers/common/searchers/skeleton.js";
import useLoading from "../../../../hooks/common/searchers/useLoading.js";
import * as S from "./styled.js";
const SearcherSwitcher = ({ searchers , id , endpoint , ajaxComponentData , searcher , config  })=>{
    const { BaseUrl  } = useContext(contextBabylon);
    const [hasError, setError] = useState(!id || !searcher && !endpoint && !ajaxComponentData);
    const [searcherData, setSearcherData] = useState(searcher);
    const getSearcherDataCallLock = useRef(false);
    const { doFetchLoading , isLoading  } = useLoading([
        getSearcherDataCallLock
    ], false);
    useEffect(()=>{
        if (!!searcherData || hasError) return;
        doFetchLoading(getSearcherDataCallLock, async ()=>{
            if (endpoint) {
                await getSearcherData(endpoint, {
                    BaseUrl
                }).then((response = {})=>setSearcherData(response.data || response.props || response));
            }
            if (ajaxComponentData) {
                await getSearcherModel(ajaxComponentData, {
                    BaseUrl
                }).then((response = {})=>setSearcherData(response.data || response.props || response));
            }
        }, ()=>setError(true));
    }, [
        BaseUrl,
        ajaxComponentData,
        doFetchLoading,
        endpoint,
        hasError,
        searcherData
    ]);
    if (hasError) {
        return /*#__PURE__*/ _jsxs(S.SearcherMessage, {
            children: [
                /*#__PURE__*/ _jsx(Icon, {
                    className: "nico-info"
                }),
                /*#__PURE__*/ _jsx("p", {
                    children: config?.literals?.informationLabel
                })
            ]
        });
    }
    const SearcherComponent = searchers[id];
    if (!SearcherComponent || !searcherData || isLoading) return renderSearcherSkeleton(id);
    return /*#__PURE__*/ _jsx(Suspense, {
        fallback: renderSearcherSkeleton(id),
        children: /*#__PURE__*/ _jsx(SearcherComponent, {
            props: searcherData
        })
    });
};
export default SearcherSwitcher;

//# sourceMappingURL=index.js.map